export default class InlineMap
{
    protected src: string;
    protected node: Element;

    public constructor(src: string, targetNodeSelector: string)
    {
        this.src  = src;
        this.node = document.querySelector(targetNodeSelector);
    }

    public getWrapperNode(): Element
    {
        return this.node;
    }

    public setSrc(src: string)
    {
        this.src = src;
    }

    public clearWrapper()
    {
        this.node.innerHTML = '';
    }

    public render()
    {
        if (!this.node) {
            return;
        }

        let script = document.createElement('script');
        script.src = this.src;
        script.type = 'text/javascript';
        script.setAttribute('async', '');
        script.setAttribute('charset', 'utf-8');

        this.node.appendChild(script);
    }
}
